<div class="page-layout simple left-sidebar inner-sidebar inner-scroll">

    <!-- HEADER -->
    <div class="header accent p-6 flex items-center">
        <!-- BOTÓN DE MENÚ -->
        <!--
        <button
            class="sidebar-toggle mr-2 md:hidden"
            (click)="toggleSidebar('simple-left-sidebar-4')">
            <mat-icon>menu</mat-icon>
        </button>
        -->

        <!-- TÍTULO -->
        <div>
            <h2 class="text-4xl font-semibold">Administración de Roles</h2>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENIDO PRINCIPAL -->
    <div class="content flex">

        <!-- SIDEBAR -->
        <!--
        <fuse-sidebar class="sidebar" name="simple-left-sidebar-4" position="left" lockedOpen="gt-md">
        -->
        <div class="sidebar p-6 overflow-y-auto">
            <entity-list
                #entityList
                title="Lista de roles"
                [values]="roles"
                (entitySelected)="selected($event)">
            </entity-list>
        </div>
        <!-- / SIDEBAR -->

        <!-- DIVISOR -->
        <div class="w-px bg-gray-200"></div>

        <!-- CONTENIDO CENTRAL -->
        <div class="center flex flex-col p-6 flex-grow">

            <!-- TÍTULO -->
            <span class="text-3xl font-semibold mb-4">Datos de rol</span>

            <!-- BOTÓN NUEVO -->
            <div *ngIf="_systemService.canAction('adminRoles')" class="pb-4 w-[600px] flex justify-end">
                <button
                    mat-raised-button
                    (click)="newRole()"
                    aria-label="Nuevo Rol"
                    class="flex items-center gap-2 bg-blue-500 text-white py-2 px-4 rounded shadow hover:bg-blue-600 transition">
                    <mat-icon>add</mat-icon>
                    <span>Nuevo</span>
                </button>
            </div>

            <!-- FORMULARIO -->
            <div class="content p-6">
                <role-form #roleForm (entityChanged)="entityChanged($event)"></role-form>
            </div>

        </div>
        <!-- / CONTENIDO CENTRAL -->

    </div>
    <!-- / CONTENIDO PRINCIPAL -->

</div>
